// @flow
import React from 'react'
import renderHTML from 'react-render-html'
import { Accordion, Icon } from 'semantic-ui-react'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'

export default class TabMobile extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 600,
      isTablet: window.innerWidth < 800
    }
  }

  render() {
    const isActive = this.props.activeIndex == this.props.index
    return (
      <div className={isActive ? 'tabMobile active mobile only' : 'tabMobile mobile only'}>
        {/* <Accordion.Title
          active={isActive}
          index={this.props.index}
          onClick={this.props.handleClick}
          className={'mobile only'}
        > */}
          <div className='arrow'>
            <Icon className={isActive ? 'arrow circle right' : 'arrow circle right'} />
          </div>
        {/* </Accordion.Title> */}
      </div>
    )
  }
}
